<template>
  <v-row
    v-if="small"
    dense
  >
    <v-col class="bg-primary p-0 pt-1">
      <div class="d-grid pa-2 bc-caption c-white">
        <span class="fw-600 me-1 mb-1">{{ $bct('Please note') }}:</span>
        <MarkdownContent :content="publicNotice" />
      </div>
    </v-col>
  </v-row>

  <v-card
    v-else
    class="c-white my-1 fs-16"
    color="primary"
    border
    flat
    tile
  >
    <v-card-title class="fs-20 fw-600"> {{ $bct('Please note') }}: </v-card-title>
    <v-card-text class="c-white my-1 fs-16">
      <MarkdownContent
        :content="publicNotice"
        class="fs-16 fw-400"
      />
    </v-card-text>
  </v-card>
</template>

<script setup>
import MarkdownContent from '@/shared/components/MarkdownContent.vue';

const $bct = inject('translator');

defineProps({
  publicNotice: {
    type: String,
    default: null,
  },
  small: {
    type: Boolean,
    default: false,
  },
});
</script>
